import { Injectable } from '@angular/core';


import { HttpClient, HttpParams } from '@angular/common/http';
import { GlobalConstants } from '../Constants/global.constants';
import { Observable } from 'rxjs';
import { AlertFilter } from '../data/enums';

@Injectable({
    providedIn: 'root'
})
export class DeviceHealthService {

    constructor(private _http: HttpClient) { }


    getAlerts(filters?: AlertFilter): Observable<any> {
        let params = new HttpParams();

        if (filters) {
            Object.entries(filters).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params = params.set(key, String(value));
            }
            });
        }

        return this._http.get(
            GlobalConstants.API_URL + 'AlertMessage/GetAllFiltered',
            { params }
        );
    }

    UpdateAlertStatus(id: string, status: any): Observable<any> {
    const url = GlobalConstants.API_URL + `AlertMessage/UpdateStatus?id=${id}&status=${status}`;
    return this._http.put(url, {});
    }

     getCosmosLatestData(request: any): Observable<any> {
        var url = GlobalConstants.API_URLs + 'api/Devices/getCosmosdatalatest';
        return this._http.post(url, request);
    }
}